import { BCCodeViewer } from '@/components/reference/BCCodeViewer';

// Standalone, login-free BC Building Code viewer — for crew phones without a
// portal session, subs, inspectors, or anyone handed the link. Read-only.
export const PublicBCCodePage = () => (
  <div className="h-screen flex flex-col bg-[#FAF6F0]">
    <header className="bg-white border-b border-gray-200 px-4 py-2.5 flex items-center gap-2 flex-shrink-0">
      <span className="text-[#C77D3F] font-bold text-lg tracking-tight">OchrePoint</span>
      <span className="text-gray-400 text-sm">· BC Building Code 2024</span>
      <a href="/portal/login" className="ml-auto text-xs text-gray-400 hover:text-gray-600">Portal sign-in</a>
    </header>
    <div className="flex-1 min-h-0 p-2">
      <BCCodeViewer canUpload={false} />
    </div>
  </div>
);
